import React, { useEffect, useState } from 'react';
import { SafeAreaView, View, Platform, RefreshControl } from 'react-native';
import { Text, Divider, Icon, Card } from 'react-native-elements';
import { connect } from 'react-redux';
import { RootState } from '../redux';
import { User } from '../utils/types/Users';
import { AgentStackParamList } from '../AgentStack';
import { StackScreenProps, StackNavigationProp } from '@react-navigation/stack';
import Firebase from '../components/FirebaseContext';
import { greet } from '../utils';
import { Projects } from '../utils/types/Projects';
import { FlatList } from 'react-native-gesture-handler';
import TouchableWrapper from '../components/TouchableWrapper';
import { fstHelper } from '../utils/types/others';
import { colors } from '../utils/constants';
import { updateProjects, UpdateProjectsAction } from '../redux/actions/ProjectsAction';
import { scale } from 'react-native-size-matters';

type NavProps = StackScreenProps<AgentStackParamList, 'Welcome'>;

interface WelcomeProps extends NavProps {
	user: User;
	projects: Array<{ docId: string; project: Projects }>;
	updateProjects: (p: Array<{ docId: string; project: Projects }>) => UpdateProjectsAction;
	navigation: StackNavigationProp<AgentStackParamList, 'Welcome'>;
}

function Welcome({ user, projects, updateProjects, navigation }: WelcomeProps) {
	const firestore = Firebase.firestore();
	const [refresh, setRefresh] = useState(true);
	useEffect(() => {
		//load all participating projects
		if (refresh) {
			firestore
				.collection('projects')
				.orderBy('stopTime', 'desc')
				.orderBy('createdAt', 'desc')
				.get()
				.then((res) => {
					if (!res.empty) {
						const p = res.docs.map((p) => {
							const converted = p.data() as Projects;
							// convert serverTimeStamp() to string before persisting
							converted.startTime = new Date((converted.startTime as fstHelper).toDate()).toDateString();
							converted.stopTime = new Date((converted.stopTime as fstHelper).toDate()).toDateString();
							return { docId: p.id, project: converted };
						});
						updateProjects(p);
						setRefresh(false);
					}
				});
		}
	}, [firestore, updateProjects, refresh]);

	return (
		<SafeAreaView style={{ flex: 1, backgroundColor: '#fff' }}>
			<View style={{ paddingHorizontal: 20, paddingVertical: Platform.OS == 'ios' ? 10 : 0, flex: 1 }}>
				<View style={{ flexDirection: 'row' }}>
					<Icon name="user" type="feather" size={scale(20)} style={{ alignSelf: 'center' }} />
					<Text style={{ fontWeight: '700', marginBottom: 10, textAlign: 'left', fontSize: scale(18) }}>
						&nbsp; {greet()} {user.firstName}
					</Text>
				</View>
				<Divider />
				<View style={{ flexDirection: 'row', marginTop: 10 }}>
					<Icon name="activity" type="feather" size={scale(20)} style={{ alignSelf: 'center' }} />
					<Text style={{ fontWeight: '700', marginBottom: scale(10), textAlign: 'left', fontSize: scale(18) }}>
						&nbsp; Projects
					</Text>
				</View>
				{/* <Divider /> */}
				<FlatList
					data={projects}
					showsVerticalScrollIndicator={false}
					refreshing={refresh}
					refreshControl={
						<RefreshControl
							refreshing={refresh}
							onRefresh={() => {
								setRefresh(true);
							}}
						/>
					}
					renderItem={({ item }) => {
						const { docId, project } = item;
						return (
							<TouchableWrapper
								onPress={() => {
									if (new Date() < new Date(project.stopTime as string)) {
										navigation.navigate('Project', { docId: docId });
									}
								}}
								activeOpacity={0.9}
							>
								<Card
									title={project.name}
									containerStyle={{
										elevation: 4,
										backgroundColor: new Date() < new Date(project.stopTime as string) ? colors.green : colors.darkRed,
										borderColor: new Date() < new Date(project.stopTime as string) ? colors.green : colors.darkRed,
									}}
									titleStyle={{ color: '#fff' }}
								>
									<Text style={{ color: '#fff' }}>{project.description}</Text>
									<Text style={{ color: '#fff' }}>
										Period: {project.startTime} &nbsp; - &nbsp; {project.stopTime}
									</Text>
								</Card>
							</TouchableWrapper>
						);
					}}
					keyExtractor={(item) => item.project.id}
					ListFooterComponent={<View style={{ height: 40 }}></View>}
				/>
			</View>
		</SafeAreaView>
	);
}

const mapStateToProps = ({ user, projects }: RootState) => {
	return {
		user,
		projects,
	};
};

const mapDispatchToProps = {
	updateProjects,
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
